<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>帖子詳情</p>
      </div>
      <el-form>
        <el-form-item label='標題:'>
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="name">
        </el-form-item>

        <el-form-item label="發佈時間:">
          
          <input disabled class="el-input__inner" type="text" v-model="createTime" @change="sort=sort.replace(/^(0+)|[^\d]+/g,'')">
          
        </el-form-item>

        <el-form-item label="內容:">
          <div>
            <div>
              <img :src="primaryPictureUrl" class="pic" alt="">
              <img :src="secondaryPictureUrl" class="pic" alt="">
              <img :src="lowlyPictureUrl" class="pic" alt="">

            </div>
            <el-input
              disabled
              type="textarea"
              :autosize="{ minRows: 2}"
              placeholder="請輸入話題簡介"
              v-model="brief">
          </el-input>
          </div>
          
        </el-form-item>

      </el-form>

    </div>
    

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'

import DiaMess from '@/components/dialog';
export default {
  data () {
    return {
      navBlock: '社區',
      navtitle: '投訴列表  /  投訴詳情',
      detailsTitle: '投訴詳情',
      name: '',
      createTime: '',
      brief: '',
      newsList: [],
      dialogVisible: false,
      id: this.$route.query.id,
      type: this.$route.query.type,
      primaryPictureUrl: '',
      secondaryPictureUrl: '',
      lowlyPictureUrl: '',
    }
  },
  created(){
    let _this = this;
    _this.getSubjectDetails();
    if(_this.type=='com') {
      _this.navtitle = '投訴列表  /  投訴帖子詳情';
    } else {
      _this.navtitle = '帖子列表  /  帖子詳情';

    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 编辑話題详情
    getSubjectDetails(){
      let _this = this;
      _this.$get(`/unity/getDetail/${_this.id}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            _this.name = res.data.list.title;
            _this.createTime = _this.$getTime(res.data.list.stickersTime);
            _this.primaryPictureUrl = res.data.list.primaryPictureUrl;
            _this.secondaryPictureUrl = res.data.list.secondaryPictureUrl;
            _this.lowlyPictureUrl = res.data.list.lowlyPictureUrl;
            _this.brief = res.data.list.context;
          } else {
            _this.$propMessage(res.message, 'error');
          }
        });
    },
    //重置內容
    reset(){
        let _this = this;
        _this.name = '';
        _this.sort = '';
        _this.brief = '';
        
    },
  },
  components: {
    NavBar,

    DiaMess
  },
};
</script>
<style scoped lang="less">
  .ql-toolbar.ql-snow + .ql-container.ql-snow{
    background:#9e9e9e;
  }
  input:disabled{
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
    cursor: not-allowed;
  }
  .pic{
    width:200px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/community/postDetails.vue